import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'full-screen-layout',
  template: require('./full-screen-layout.component.html'),
  styles: [require('./full-screen-layout.component.scss')],
})
export class FullScreenLayoutComponent {}
